import {
    RaikoGridOneColumn,
    convertUniversalDateToPersianDate,
    showServerErrorMessage,
    RaikoBaseCardContainer,
    RaikoSectionContainer,
    RaikoGridTwoColumn,
    RaikoDatePicker,
    RaikoSimpleInputOutlined, RaikoNumberInputOutlined, RaikoSimpleMultiLineInputOutlined,
    convertPersianDateToUniversalDate, showSuccessMessage, RaikoCreatorInfo, convertUniversalDateTimeToPersianDateTime
} from "@moeindal/base-raiko-panel-components";
import LanguageSelector from "../../../component/languageSelector/LanguageSelector";
import React, {useEffect, useRef, useState} from "react";
import {PeriodService} from "../../../serverService/periodService/PeriodService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {HabitationSettings} from "./HabitationSettings";


export default function PeriodBasicInfo({periodId}) {

    const service = new PeriodService();

    const loading = new LoadingHelper(useLoadingDispatcher());



    const [languageId, setLanguageId] = useState();
    const [periodName, setPeriodName] = useState("")
    const [rules, setRules] = useState("");
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [numberOffDaysAllowed, setNumberOffDaysAllowed] = useState("")
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    const [acceptationState, setAcceptationState] = useState(false);
    const [automaticAcceptanceState, setAutomaticAcceptanceState] = useState(false);

    const [limit, setLimit] = useState(false);
    const [limitAmount, setLimitAmount] = useState(20);


    function getDataFromServer(languageCode) {
        loading.show()
        service.getPeriodDetail(periodId, languageCode)
            .then(response => {
                setPeriodName(response.metaData.title ? response.metaData.title : "")

                setNumberOffDaysAllowed(response.numberOfDaysAllowed ? response.numberOfDaysAllowed : "")
                setRules(response.metaData.rules ? response.metaData.rules : "")
                setStartDate(convertUniversalDateToPersianDate(response.startDate))
                setEndDate(convertUniversalDateToPersianDate(response.endDate))

                setAcceptationState(response.acceptation)
                setAutomaticAcceptanceState(response.automaticAcceptance)

                setLimit(response.automaticAcceptanceLimit)
                setLimitAmount(response.automaticAcceptanceLimitNumber)

                setCreatedBy(response.createdBy)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdatePeriodBasicInfo() {
        loading.show()
        service.updatePeriodDetail(
            periodId,
            languageId,
            periodName,
            numberOffDaysAllowed,
            rules,
            convertPersianDateToUniversalDate(startDate),
            convertPersianDateToUniversalDate(endDate),
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_=>{
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn>
            <LanguageSelector languageId={languageId} setLanguageId={setLanguageId} handleGetInfo={getDataFromServer}/>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه و چند زبانه"}
                    hasActionButton
                    actionButtonOnclickWithValidation={handleUpdatePeriodBasicInfo}
                >
                    <RaikoGridOneColumn>
                        <RaikoGridTwoColumn>
                            <RaikoDatePicker
                                label={"تاریخ شروع"}
                                date={startDate}
                                setDate={setStartDate}
                                required
                            />
                            <RaikoDatePicker
                                label={"تاریخ پایان"}
                                date={endDate}
                                setDate={setEndDate}
                                required
                            />
                            <RaikoSimpleInputOutlined
                                labelText={"نام دوره زمانی"}
                                setValue={setPeriodName}
                                value={periodName}
                                required
                            />
                            <RaikoNumberInputOutlined
                                labelText={"حداکثر روز اقامت"}
                                value={numberOffDaysAllowed}
                                setValue={setNumberOffDaysAllowed}
                                required
                            />
                        </RaikoGridTwoColumn>
                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"قوانین"}
                            setValue={setRules}
                            multiline={true}
                            row={10}
                            value={rules}
                            required
                        />
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <HabitationSettings
                id={periodId}
                automaticAcceptanceState={automaticAcceptanceState}
                acceptationState={acceptationState}
                limit={limit}
                limitNumber={limitAmount}
            />
            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
        </RaikoGridOneColumn>
    )
}